import { render, staticRenderFns } from "./muscle.vue?vue&type=template&id=68e76768"
import script from "./muscle.vue?vue&type=script&lang=js"
export * from "./muscle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports